const browser = typeof window !== "undefined" && window
export const actionCodeSettings = browser
  ? {
      url: window.location.origin + "/verify",
      handleCodeInApp: true,
    }
  : console.log("Not a browser")
